import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const FormConnectionModal = ({ tramite, formularios, onConnect, onClose }) => {
    const [selectedFormId, setSelectedFormId] = useState('');

    const handleSubmit = (e) => {
      e.preventDefault();
      if (!selectedFormId) {
        success('Selecciona un formulario');
        return;
      }
      onConnect(selectedFormId);
    };
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1200]">
        <div className="bg-white rounded-lg max-w-md w-full mx-4">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">
                🔗 Conectar Formulario
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <X />
              </button>
            </div>
          </div>
  
          <form onSubmit={handleSubmit} className="p-6">
            <div className="mb-6">
              <h4 className="font-medium text-gray-900 mb-2">Trámite:</h4>
              <p className="text-gray-600">{tramite.name}</p>
            </div>
  
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Seleccionar Formulario *
              </label>
              <select
                value={selectedFormId}
                onChange={(e) => setSelectedFormId(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              >
                <option value="">Selecciona un formulario...</option>
                {formularios.map((form) => (
                  <option key={form._id} value={form._id}>
                    {form.name}
                  </option>
                ))}
              </select>
            </div>
  
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                🔗 Conectar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default FormConnectionModal;